import { ContentElementFaqs as CeFaqs, composeStyles } from '@vgn-medien-holding/vgn-fe-components';
import elementStyle from './styles/default';

export default function ContentElementFaqs(element) {
  if (!element) return null;
  return (
    <CeFaqs
      element={element}
      collapsible={element?.columns_amount !== 2}
      classProps={composeStyles(
        elementStyle,
        element?.columns_amount === 2 ? { faqRoot: 'grid md:grid-cols-2 gap-x-6' } : {},
      )}
    />
  );
}
